import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChangeLog } from "./change-log.model";
import { Permissions } from "../../core/constants/permissions";

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html'
})
export class ChangeLogComponent {
  @Output() exportClicked = new EventEmitter<void>();
  @Output() pageChanged = new EventEmitter<number>();

  @Input() results: ChangeLog
  @Input() hideExportBtn = false;
  @Input() dataLoaded: boolean = false;

  loaderArray: number[] = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

  protected readonly Permissions = Permissions;

  onChangePage(page: number) {
    this.pageChanged.emit(page);
  }
}
